/**
 * Handle accordions
 */

$('.js-accordion-faq').on('click', '.accordion__head', function() {
	const $this = $(this);
	const headerHeight = $('.header').outerHeight();
	const $sibling = $this.siblings();
	const $parent = $this.closest('.js-accordion-faq');

	if ($parent.hasClass('accordion-scroll')) {

		if (!$this.parent().hasClass('is-current')) {
			setTimeout(()=> {
				$('html, body').animate({
					scrollTop: $this.offset().top - headerHeight
				}, 500)
			}, 400);
		}
	}

	$sibling.slideToggle();

	$this.parent()
		.toggleClass('is-current')
		.siblings()
		.removeClass('is-current')
		.children('.accordion__body')
		.slideUp();
})
